import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import utils from "../../../utils/utils";
import BodySeparator from "../../../components/customComp/BodySeparator";
import UsersList from "./UsersList";

const UsersBody = (props) => {
  const { usersData, addTab, handleDropDownChange } = props;
  return (
    <div
      className={
        "flex-col flex w-full h-full max-h-[85%] mt-10 overflow-hidden"
      }
    >
      <div className="listLabels text-white font-Inter opacity-50 text-[13px] font-normal flex">
        <div className="ml-[30px] w-userName">Name</div>
        <div className="w-userEmail">Email address</div>
        <div className="w-userPhone">Phone Number</div>
        <div className="w-userHCP">Site</div>
        <div className="min-w-[103px]">Status</div>
        <div className="min-w-[124px] ml-14">Role</div>
      </div>
      {/* <BodySeparator text={`Findings (${patientCount})`} marginBottom="22px"/> */}

      <UsersList
        users={usersData}
        restApi={props.restApi}
        handleDropDownChange={(index, name, value) =>
          handleDropDownChange(index, name, value)
        }
        addTab={addTab}
        onRowClick={(index) => props.onRowClick(index)}
      />
    </div>
  );
};

export default UsersBody;
